<script lang="ts">
  import { dayjs } from '../../lib/dayjs';
  import { onDestroy, onMount } from 'svelte';
  import VerifyAndApprove from './verify-and-approve.svelte';
  import RejectionReasonModal from '../_shared/RejectionReasonModal.svelte';
  import AiVerificationModal from '../_shared/AiVerificationModal.svelte';
  import BulkAiProgressModal from '../_shared/BulkAiProgressModal.svelte';
import { executeBulkAiVerification, type BulkProgressState } from '../../lib/bulkAiVerification';

  import EventQueue from '../../lib/custom-event';
  import { debugLog } from '../../lib/debug-log';
  import { getAuthHeaders } from '../../lib/authHeaders';
  import {
    getStandardFieldTransformations,
    CRITERIA_STATUS_FIELDS,
    CRITERIA_HIDDEN_FIELDS,
    ALL_CRITERIA_FIELDS,
    CRITERIA_DROPDOWN_FIELDS,
  } from '../../lib/agentTransformations';
  import BulkTransferProgressModal from '../_shared/BulkTransferProgressModal.svelte';
  import {
    executeBulkTransfer,
    type BulkTransferProgressState,
  } from '../../lib/bulkTransfer';

  let row = null;
  let URL = `${process.env.SVELTE_APP_REMOTE_URL}/api`;

  const mountAdminView = () => {
    document.getElementById('verification').innerHTML = '';

    import('App/Purchasepaybacks').then((m) => {
      let module = m.default;

      new module({
        target: document.getElementById('verification'),
        layout: 'auto',
        props: {
          dateFormat: 'DD.MM.YYYY - HH:mm',
          filter: {
            limit: 10,
            where: {
              and: [
                {
                  completed: 1,
                  status: 'VERIFICATION',
                },
              ],
            },
          },
          defaultFilter: {
            date: {
              lt: dayjs().format(),
              gt: dayjs().subtract(7, 'day').format(),
            },
          },
          quickFilters: [
            {
              label: 'Last day',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(1, 'day').format(),
                },
              },
            },
            {
              label: 'Last 2 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(2, 'day').format(),
                },
              },
            },
            {
              label: 'Last 3 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(3, 'day').format(),
                },
              },
            },
            {
              label: 'Last 5 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(5, 'day').format(),
                },
              },
            },
            {
              label: 'Last 7 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(7, 'day').format(),
                },
              },
            },
            {
              label: 'Last 30 days',
              filter: {
                date: {
                  lt: dayjs().format(),
                  gt: dayjs().subtract(30, 'day').format(),
                },
              },
            },
            {
              label: 'Any Criterion Failed',
              filter: {
                or: [
                  { criterion1Status: 'FAILED' },
                  { criterion2Status: 'FAILED' },
                  { criterion3Status: 'FAILED' },
                  { criterion4Status: 'FAILED' },
                  { criterion5Status: 'FAILED' },
                  { criterion6Status: 'FAILED' },
                  { criterion7Status: 'FAILED' },
                  { criterion8Status: 'FAILED' },
                  { criterion9Status: 'FAILED' },
                ],
              },
            },
          ],
          schema: {
            'field-properties': {
              'field-order': [
                'id',
                'date',
                'completed',
                'status',
                'agentDecision',
                'agentFindings',
                ...CRITERIA_STATUS_FIELDS,
                'cashbackType',
                'personalinformation',
                'purchasereceipts',
                'questions',
              ],
              'field-transformation': getStandardFieldTransformations(),
              'auto-generated-fields': ['id'],
              'boolean-fields': [
                'completed',
                'personalinformationOverride',
                'archived',
                'ibanVerified',
                'phoneVerified',
                'addressVerified',
                'dealerOverride',
                'partsOverrride',
                'purchaseDateOverride',
                'storageOverride',
                'switchOverride',
              ],
              'hidden-fields': [
                'rejectionReason',
                'paidDate',
                'paidByMbdDate',
                ...CRITERIA_HIDDEN_FIELDS,
              ],
              'readonly-fields': [
                'id',
                'purchasereceipts',
                'purchasereceiptsId',
                'personalinformation',
                'personalinformationId',
                'agentDecision',
                'agentFindings',
                ...ALL_CRITERIA_FIELDS,
              ],
              'textarea-fields': ['agentFindings'],
              'relational-fields': [
                {
                  name: 'personalinformation',
                  editable: true,
                  // columns: ["id", "name", "vorname", "geburtstag", "notizen"],
                },
                {
                  name: 'purchasereceipts',
                  editable: true,
                  // columns: ["id", "name", "vorname", "geburtstag", "notizen"],
                },
              ],
              'dropdown-fields': [
                {
                  name: 'status',
                  default: {
                    label: 'VERIFICATION',
                    value: 'VERIFICATION',
                  },
                  options: [
                    {
                      label: 'INCOMPLETE',
                      value: 'INCOMPLETE',
                    },
                    {
                      label: 'REJECTED',
                      value: 'REJECTED',
                    },
                    {
                      label: 'VERIFICATION',
                      value: 'VERIFICATION',
                    },
                    {
                      label: 'PRE-APPROVED',
                      value: 'PRE-APPROVED',
                    },
                    {
                      label: 'APPROVED',
                      value: 'APPROVED',
                    },
                    {
                      label: 'PRE-PAYMENT',
                      value: 'PRE-PAYMENT',
                    },
                    {
                      label: 'PAID',
                      value: 'PAID',
                    },
                    {
                      label: 'PARKING1',
                      value: 'PARKING1',
                    },
                    {
                      label: 'PARKING2',
                      value: 'PARKING2',
                    },
                    {
                      label: 'PARKING3',
                      value: 'PARKING3',
                    },
                    {
                      label: 'PARKING4',
                      value: 'PARKING4',
                    },
                    {
                      label: 'PARKING5',
                      value: 'PARKING5',
                    },
                    {
                      label: 'transferred to mbdcb140',
                      value: 'transferred to mbdcb140',
                    },
                  ],
                },
                {
                  name: 'cashbackType',
                  default: {
                    label: 'cashback-full',
                    value: 'cashback-full',
                  },
                  options: [
                    // DISABLED: cashback-basic (100€) not available this year
                    // {
                    //   label: 'cashback-basic',
                    //   value: 'cashback-basic',
                    // },
                    {
                      label: 'cashback-full',
                      value: 'cashback-full',
                    },
                    {
                      label: 'not-cashback-eligible',
                      value: 'not-cashback-eligible',
                    },
                  ],
                },
                ...CRITERIA_DROPDOWN_FIELDS,
              ],
              'json-fields': [
                {
                  field: 'address',
                  template: '${street}, ${zip} ${city}',
                },
              ],
            },
            'custom-bulk-actions': [
              {
                action: 'transfer to mbdcb140',
                bulkFn: async (rows) => {
                  const numericIds = rows
                    .map((r: any) =>
                      typeof r === 'object' && r !== null ? Number(r.id) : Number(r),
                    )
                    .filter((id: number) => !isNaN(id) && id > 0);
                  await triggerBulkTransfer(numericIds);
                  return rows.map(() => Promise.resolve());
                },
                singleFn: async (row) => {
                  await triggerBulkTransfer([row.id]);
                },
              },
              {
                action: 'Incomplete',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'INCOMPLETE',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  return promises;
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'INCOMPLETE',
                      },
                    },
                  });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
              {
                action: 'Approve',
                bulkFn: async (rows) => {
                  const promises = rows.map(async (row) => {
                    const getResponse = await fetch(
                      `${URL}/purchasepaybacks/${row}`,
                      {
                        method: 'GET',
                        headers: getAuthHeaders(),
                      },
                    );
                    const response = await getResponse.json();
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'APPROVED',
                            approvedDate:
                              response.approvedDate &&
                              response.approvedDate !== 'Invalid Date'
                                ? undefined
                                : new Date().toISOString(),
                          },
                        },
                      });

                      window.dispatchEvent(event);
                      requestAnimationFrame(() => resolve(undefined));
                    });
                  });
                  return Promise.all(promises);
                },
                singleFn: (row) => {
                  const event = new CustomEvent('updateRow', {
                    detail: {
                      rowId: row.id,
                      fields: {
                        status: 'APPROVED',
                        approvedDate:
                          row.approvedDate &&
                          row.approvedDate !== 'Invalid Date'
                            ? undefined
                            : new Date().toISOString(),
                      },
                    },
                  });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
              {
                action: 'Reject',
                bulkFn: async (rows) => {
                  const promises = rows.map((row) => {
                    return new Promise((resolve) => {
                      const event = new CustomEvent('updateRow', {
                        detail: {
                          rowId: row,
                          fields: {
                            status: 'REJECTED',
                          },
                        },
                      });
                      window.dispatchEvent(event);
                      resolve();
                    });
                  });

                  return promises;
                },
                singleFn: (row) => {
                  rowInstance = row;
                  rejectionReasonModalOpen = true;
                  // return selectedids;
                },
              },
              {
                action: 'Verify and Approve',
                singleFn: (row) => {
                  const event = new CustomEvent('approve', { detail: row });
                  window.dispatchEvent(event);
                  // return selectedids;
                },
              },
              {
                action: 'Run AI Verification',
                bulkFn: async (rows) => {
                  const numericIds = rows
                    .map((r: any) =>
                      typeof r === 'object' && r !== null ? Number(r.id) : Number(r),
                    )
                    .filter((id: number) => !isNaN(id) && id > 0);
                  await triggerBulkAiVerification(numericIds);
                  return rows.map(() => Promise.resolve());
                },
                singleFn: (row: { id: number }) => {
                  runAiVerification(row.id);
                },
              },
            ],
          },
        },
      });
    });
  };

  // AI verification: the "Run AI Verification" row action posts just the process id to the
  // agent (grases/gras/grapi/injections/verify-receipt.controller.ts) and shows the
  // returned findings + recommendation in a modal. The backend stores the recommendation on
  // the record (agentDecision / agentFindings) but leaves the workflow status untouched
  // (unless the agent says APPROVABLE, which moves it to PRE-APPROVED).
  let handleFindingsClick: (e: MouseEvent) => void;
  let aiModalOpen = false;
  let aiLoading = false;
  let aiProcessId: number | null = null;
  let aiDecision: 'APPROVABLE' | 'UNSURE' | 'NOT_APPROVABLE' | null = null;
  let aiFindings = '';
  let aiError = '';

  let bulkProgress: BulkProgressState = {
    open: false,
    total: 0,
    processed: 0,
    completed: 0,
    failed: 0,
    percent: 0,
    status: 'starting',
    message: '',
  };

  let bulkTransferProgress: BulkTransferProgressState = {
    open: false,
    total: 0,
    processed: 0,
    completed: 0,
    failed: 0,
    percent: 0,
    status: 'starting',
    message: '',
  };

  const triggerBulkTransfer = async (ids: number[]) => {
    if (!ids || ids.length === 0) return;
    await executeBulkTransfer(
      ids,
      URL,
      (state) => {
        bulkTransferProgress = state;
      },
      () => {
        EventQueue.trigger('refreshTable', {});
      },
    );
  };

  const triggerBulkAiVerification = async (ids: number[]) => {
    if (!ids || ids.length === 0) return;
    await executeBulkAiVerification(
      ids,
      URL,
      (state) => {
        bulkProgress = state;
      },
      () => {
        EventQueue.trigger('refreshTable', {});
      },
    );
  };

  const runAiVerification = async (id: number) => {
    aiProcessId = id;
    aiDecision = null;
    aiFindings = '';
    aiError = '';
    aiLoading = true;
    aiModalOpen = true;
    try {
      const response = await fetch(`${URL}/purchasepaybacks/${id}/verify`, {
        method: 'POST',
        headers: getAuthHeaders(),
      });
      if (!response.ok) {
        const errData = await response.json().catch(() => null);
        throw new Error(errData?.error?.message || errData?.message || `Verification failed (status ${response.status})`);
      }
      const result = await response.json();
      const verdict = result?.verdict;
      if (!verdict) {
        aiError = 'The agent did not return a result.';
      } else {
        aiDecision = verdict.decision ?? null;
        aiFindings = verdict.findings ?? '';
        // The result is now stored on the record; refresh the table so the agentDecision
        // and agentFindings columns reflect it.
        if (result.stored) mountAdminView();
      }
    } catch (e) {
      aiError = (e as Error).message ?? 'AI verification failed.';
    } finally {
      aiLoading = false;
    }
  };

  onMount(() => {
    mountAdminView();
    // listen to the approve event in the global context
    // and update the state of the child component
    window.addEventListener('updateRow', (e: any) => {
      // e.detail.row is row.id
      eventQueue.enqueue(e.detail);
    });

    handleFindingsClick = (e: MouseEvent) => {
      const chip = (e.target as HTMLElement)?.closest('.agent-findings-chip');
      if (!chip) return;
      const idStr = chip.getAttribute('data-id');
      const findings = chip.getAttribute('data-findings');
      const decision = chip.getAttribute('data-decision');
      if (findings) {
        aiProcessId = idStr ? Number(idStr) : null;
        aiFindings = decodeURIComponent(findings);
        aiDecision = (decision as any) || null;
        aiError = '';
        aiLoading = false;
        aiModalOpen = true;
      }
    };
    document.addEventListener('click', handleFindingsClick);
  });

  onDestroy(() => {
    // remove the event listener
    window.removeEventListener('updateRow', (e: any) => {
      debugLog(e.detail);
    });
    if (handleFindingsClick) {
      document.removeEventListener('click', handleFindingsClick);
    }
  });

  const updateRow = async (
    detail: { rowId: string; fields: any },
    skipMount = false,
  ) => {
    try {
      await fetch(`${URL}/purchasepaybacks/${detail.rowId}`, {
        method: 'PATCH',
        headers: getAuthHeaders(),
        body: JSON.stringify(detail.fields),
      });
    } catch (err) {
      console.error('updateRow failed:', err);
    } finally {
      if (!skipMount) mountAdminView();
    }
  };

  let progressBar: any;
  let showProgressBar = false;

  const updateProgressBar = (progress: number) => {
    debugLog({ progress });
    progressBar.style.width = `${progress}%`;
  };

  let eventQueue = new EventQueue(
    updateProgressBar,
    updateRow,
    (show: boolean) => {
      showProgressBar = show;
    },
  );

  let rowInstance = null;
  let rejectionReason = '';
  let rejectionReasonModalOpen = false;

  const closeModal = () => (rejectionReasonModalOpen = false);

  const confirmRejection = async () => {
    const event = new CustomEvent('updateRow', {
      detail: {
        rowId: rowInstance.id,
        fields: {
          status: 'REJECTED',
          rejectionReason,
        },
      },
    });
    window.dispatchEvent(event);
    closeModal();
  };
</script>

<!-- Adobe Embed API -->
<!-- <svelte:head>
  <script src="https://acrobatservices.adobe.com/view-sdk/viewer.js"></script>
</svelte:head> -->

<RejectionReasonModal
  bind:inputValue={rejectionReason}
  submitFunction={confirmRejection}
  bind:open={rejectionReasonModalOpen}
/>

<AiVerificationModal
  bind:open={aiModalOpen}
  loading={aiLoading}
  processId={aiProcessId}
  decision={aiDecision}
  findings={aiFindings}
  errorMessage={aiError}
/>

<BulkAiProgressModal
  bind:open={bulkProgress.open}
  progress={bulkProgress.percent}
  processed={bulkProgress.processed}
  total={bulkProgress.total}
  completed={bulkProgress.completed}
  failed={bulkProgress.failed}
  status={bulkProgress.status}
  message={bulkProgress.message}
  results={bulkProgress.results}
/>

<BulkTransferProgressModal
  bind:open={bulkTransferProgress.open}
  progress={bulkTransferProgress.percent}
  processed={bulkTransferProgress.processed}
  total={bulkTransferProgress.total}
  completed={bulkTransferProgress.completed}
  failed={bulkTransferProgress.failed}
  status={bulkTransferProgress.status}
  message={bulkTransferProgress.message}
  results={bulkTransferProgress.results}
/>

<VerifyAndApprove {mountAdminView} bind:row />

<div id="verification" />

<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/50 backdrop-blur-sm transition-opacity duration-300 {showProgressBar
    ? 'opacity-100'
    : 'pointer-events-none opacity-0'}"
>
  <div class="w-11/12 max-w-md rounded-lg bg-white p-6 shadow-xl">
    <div class="mb-3">
      <h3 class="text-lg font-medium text-gray-900">Processing...</h3>
      <p class="text-sm text-gray-500">
        Please wait while we update the records.
      </p>
    </div>

    <div class="h-2 w-full overflow-hidden rounded-full bg-gray-200">
      <div
        bind:this={progressBar}
        class="h-full w-0 rounded-full bg-blue-600 transition-all duration-300 ease-out"
      ></div>
    </div>
  </div>
</div>
